import { BGStatusType } from '../../../app/shared/Enums/BGStatusType';
import { CarrierTrackingPreference } from './FUMCarrier';

export class FUMUpdateCarrier {
  constructor(
    public carrierCode: string,
    public carrierName: string,
    public carrierDbaName: string,
    public customerName: string,
    public status: BGStatusType,
    public isPay: boolean,
    public trackingPreference: CarrierTrackingPreference
  ) {}
}
